import styled from 'styled-components';
import { SecondaryButton } from 'ui/button';
import { Divider } from 'ui/divider';
import { Delete } from 'ui/icons';
import { GroupSelect } from 'ui/indexPages/tables/groupSelect';
import { button, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p15: pxToRem(15),
  p25: pxToRem(25),
  p28: pxToRem(28),
  p136: pxToRem(136),
  p344: pxToRem(344),
  p1100: pxToRem(1100),
};

export const CheckboxWrapper = styled.div`
  margin-left: -${customSpacing.p25};
`;

export const TableDivider = styled(Divider)`
  height: ${spacing.single};
  margin-bottom: ${customSpacing.p28};
  margin-top: 0;
`;

export const TableWrapper = styled.div`
  min-width: ${customSpacing.p1100};
  margin-top: ${spacing.base};
`;

const HeaderButton = styled.button`
  ${button}
  background: none;
  border: none;
  padding: ${spacing.half} 0;
  outline: none;

  span {
    display: inline-block;
    margin-right: ${spacing.quarter};
  }
`;

type StyledHeaderButtonProps = {
  isSortable: boolean;
  isActiveSortColumn: boolean;
  isRightAligned: boolean;
};

export const StyledHeaderButton = styled(HeaderButton)<StyledHeaderButtonProps>`
  text-align: left;
  color: ${(props) => {
    if (!props.isSortable) {
      return colors.textPrimary;
    }
    return props.isActiveSortColumn ? colors.brandPurple : colors.textPrimary;
  }};
  display: flex;
  align-items: center;
  ${(props) =>
    props.isRightAligned ? 'justify-content: flex-end;' : 'justify-content: flex-start;'}
`;

export const InPageStyledHeaderButton = styled(StyledHeaderButton)<StyledHeaderButtonProps>`
  padding: 0;
  display: flex;
  /** only ID is right aligned */
  ${(props) =>
    props.isRightAligned
      ? 'justify-content: flex-end; padding-right: 2px;'
      : 'justify-content: flex-start;'}
`;

export const StyledGroupSelect = styled(GroupSelect)`
  margin-left: ${customSpacing.p15};
`;

export const StyledButton = styled(SecondaryButton)`
  padding: 0 ${spacing.half};
`;

export const StyledDeleteIcon = styled(Delete)`
  margin-right: ${spacing.quarter};
`;

export const StyledDisabledActionMenuWrapper = styled.div`
  align-self: center;
  display: inline-block;
  position: relative;
`;
